import React from 'react'
import { NavLink } from 'react-router-dom'
import yettocome from '../image/yettocome.png'

const Varietyshows4 = () => {
  return (
    <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden h-screen">
      <div>
      <NavLink to="/varietydetails"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 p-5" href="https://www.youtube.com/watch?v=kXpOEzNZ8hQ">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={yettocome} alt="Image Description"/>
      </div>
      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Concert Film
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-500 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          BTS Yet to Come
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3 mb-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Concert Film
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>  November 9, 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Runtime: </span>TBD8 hrs 31 mins
          </p>
          </div>

            {/* <!-- colllapse --> */}
          {/* <div class="mt-0 sm:mt-auto">
            <p class="text-gray-500 dark:text-gray-600 font-semibold">
            On October 16, 2023, Prime Video announced the release of 'BTS: Yet to Come'
</p>
<div id="hs-show-hide-collapse-heading" class="hs-collapse hidden w-full overflow-hidden transition-[height] duration-300" aria-labelledby="hs-show-hide-collapse">
  <p class="text-gray-500 dark:text-gray-600 font-semibold">
  concert film featuring BTS' 'Yet to Come' live concert held on October 15, 2022 in Busan, South Korea promoting the city's bid to host the 2030 World Expo. The concert film produced by HYBE and CJ 4DPlex will include 19 performances of BTS' hit tracks, touching speeches, electrifying stages, spectacular fireworks, and more.
'BTS: Yet to Come' will be available to stream on November 9, 2023 in 240 countries and territories worldwide on Prime Video.
  </p>
</div>
<p class="mt-2">
  <button type="button" class="hs-collapse-toggle inline-flex items-center gap-x-1 text-sm font-semibold rounded-lg border border-transparent text-blue-600 hover:text-blue-800 disabled:opacity-50 disabled:pointer-events-none dark:text-blue-500 dark:hover:text-blue-400 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" id="hs-show-hide-collapse" data-hs-collapse="#hs-show-hide-collapse-heading">
    <span class="hs-collapse-open:hidden">Read more</span>
    <span class="hs-collapse-open:block hidden">Read less</span>
    <svg class="hs-collapse-open:rotate-180 flex-shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
  </button>
</p>
          </div> */}
                      {/* <!-- collapse --> */}

        </div>
      </div>
    </a> </NavLink>
    <hr class="border-purple-500 mt-5"></hr>

<div>
  <div className='flex justify-center'>
     <h1 className='font-bold text-2xl p-2 text-blue-500'>About the show</h1>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>On October 16, 2023, Prime Video announced the release of 'BTS: Yet to Come' concert film featuring BTS' 'Yet to Come' live concert held on October 15, 2022 in Busan, South Korea promoting the city's bid to host the 2030 World Expo. The concert film produced by HYBE and CJ 4DPlex will include 19 performances of BTS' hit tracks, touching speeches, electrifying stages, spectacular fireworks, and more. </p>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>'BTS: Yet to Come' will be available to stream on November 9, 2023 in 240 countries and territories worldwide on Prime Video. </p>
  </div>
  {/* <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>2022 Tour Dates:
Las Vegas: April 8, 9, 15, 16</p>
  </div> */}
  {/* <div className='text-2xl font-bold text-blue-500 p-4'>
  EPISODES
  </div>
  <div className='text-purple-500 text-xl font-semibold p-1 ml-7'>
      <p>Dec 20, 2023: Ep 1 & 2 at 12 am PT/3am ET</p>
<p>Dec 27, 2023: Ep 3 & 4 at 12 am PT/3am ET</p>
<p>Jan 3, 2024:   Ep 5 & 6 at 12 am PT/3am ET</p>
<p>Jan 10, 2024: Ep 7 & 8 at 12 am PT/3am ET</p>
  </div> */}

</div>
      </div>
    </div>
  )
}

export default Varietyshows4
